import { createFileRoute } from "@tanstack/react-router";
import { ExpertsPage } from "@/pages/trust/TrustPages";
import { breadcrumbJsonLd } from "@/config/seoConfig";
import { seoHead } from "@/lib/seo/head";
import { EXPERTS, expertPersonNode } from "@/content/trust/experts";

export const Route = createFileRoute("/experts")({
  head: () =>
    seoHead({
      title: "Our Experts and Reviewers",
      description: "How child-development and psychology experts review LeadXkids courses and parent guides, and where verified reviewer profiles are listed.",
      canonical: "/experts",
      pageType: "WebPage",
      jsonLd: [
        breadcrumbJsonLd([
          { name: "Home", url: "/" },
          { name: "Experts", url: "/experts" },
        ]),
        ...EXPERTS.map(expertPersonNode),
      ],
    }),
  component: ExpertsPage,
});
